import React, { Component, useEffect } from 'react';
import CardRoom from './CardHistory.js';
import HistorySearch from './HistorySearch.js';
import axios from 'axios';
import { MENU } from '../Sidebar.js';
import { USER_TYPE } from '../../App.js';
import * as $ from 'jquery';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import RoomResevation from './RoomUpdateReservation.js';
import RoomCandelationReservation from './RoomCancelationReservation.js';

export const FILTER = {
  ALL: "1",
  USER: "2"
};

let cancelToken;
let state;
let tokenSession;

class HistoryContainer extends Component {

  getInitState = () => {
    return {
      filter: FILTER.ALL,
      filteredReservations: null,
      reservationsIncoming: null, //
      reservationDate: null,
      candelarReservation: null,
      isLoading: false,
    };
  }

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentDidMount() {
    this.reload();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  reload = () => {
    this.getReservations({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
    });
  }

  getReservations = (params) => {
    this.setState({ isLoading: true });
    this.props.post(
      "/getReservations",
      params,
      (response) => {
        this.didGetReservations(response)
        this.setState({ isLoading: false });
      },
      (error) => {
        this.handleErrorResponse(error)
        this.setState({ isLoading: false });
      },
      cancelToken
    );
  }

  didGetReservations = (response) => {

    this.setState({
      reservationsIncoming: response.incoming,
      reservationsPast: response.past
    });
  }

  handleErrorResponse = (error) => {
    this.setState({ error: error });
  }

  handleFilterChange = (event) => {
    this.setState({ filter: event.target.value });
  }

  updateReservation = (reservation) => {
    this.setState({
      reservationDate: reservation
    });
    var boton = document.getElementById('btnSuccess');
    boton.click();
  }

  cancelarReservation = (reservation) => {
    this.setState({
      candelarReservation: reservation
    });
    var boton_cancelacion = document.getElementById('btnSuccessCancelacion');
    boton_cancelacion.click();
  }


  handleSearchSubmit = (event) => {

  }

  renderHistorySearch = () => {
    return (
      <HistorySearch
        filter={this.state.filter}
        handleFilterChange={this.handleFilterChange}
        handleSearchSubmit={this.handleSearchSubmit} />
    );
  }

  renderRoomCardIncoming = () => {
    return (
      <CardRoom
        rooms={this.state.reservationsIncoming}
        isPast={false}
        updateReservation={this.updateReservation}
        cancelarReservation={this.cancelarReservation}
        usert={this.props.user.memberId}
      />
    )
  }

  renderRoomCardPast = () => {
    return (
      <CardRoom
        rooms={this.state.reservationsPast}
        isPast={true}
      />
    )
  }


  renderRoomResevation = (props) => {
    return (
      <RoomResevation
        reservation={props}
        getTokenId={this.props.getTokenId}
        getTokenSession={this.props.getTokenSession}
        handleErrorResponse={this.props.handleErrorResponse}
        reload={this.props.reload}
        post={this.props.post}
        user={this.props.user}
      />
    )
  }

  cencelarReservation = (props) => {
    return (
      <RoomCandelationReservation
        reservation={props}
        getTokenId={this.props.getTokenId}
        getTokenSession={this.props.getTokenSession}
        handleErrorResponse={this.props.handleErrorResponse}
        reload={this.props.reload}
        post={this.props.post}
        user={this.props.user}
      />
    )
  }




  render() {
    const { t } = this.props;
    const member = this.props.user.member
    // Si el usuario es de tipo 3 o 4, entonces tiene permiso para ver el historial
    // 3 -> Staff
    // 4 -> Permiso explicito

    const permission = member === 3 || member === 4;

    return (
      <div className="content-history">
        <div className="page-header container-history-title">
          <h2 className="history-title">{t('dashboard.history.heading')}</h2>
        </div>
        <div>
          {
            permission && (
              <div className="content-history-search">
                {this.renderHistorySearch()}
              </div>
            )
          }
          {this.state.reservationsPast || this.state.reservationsIncoming ? (
            <div className="content-history-content">
              <div className="list-card-history">
                <div className="list-card-panel-seccion">
                  <div className="content-card-panel-seccion">
                    <div id="rooms">
                      {this.renderRoomCardIncoming()}
                    </div>
                    <div id="rooms">
                      {this.renderRoomCardPast()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
              this.state.isLoading ? (
                <div className="content-loading center">
                  <h2>Cargando...</h2>
                  <div className="loader"></div>
                </div>
              ) : (
              <div>
                <h2 className="page-header">
                  {t('dashboard.history.no_results')}
                </h2>
              </div>
            )
          )}
        </div>
        <div className="resvation_expancion">
          {this.renderRoomResevation(this.state.reservationDate ? this.state.reservationDate : '')}
        </div >
        <div className="resvation_cancelacion">
          {this.cencelarReservation(this.state.candelarReservation ? this.state.candelarReservation : '')}
        </div >
      </div>
    )
  }

}
export default compose(
  translate('common'),
  withRouter
)(HistoryContainer);



// WEBPACK FOOTER //
// ./src/dashboard/history/HistoryContainer.js